import { useTranslation } from "react-i18next";
import PortalConsentsCard from "../components/portal/PortalConsentsCard";
import PortalDeleteDataCard from "../components/portal/PortalDeleteDataCard";
import PortalExportCard from "../components/portal/PortalExportCard";
import PortalFeedbackCard from "../components/portal/PortalFeedbackCard";
import PortalNotificationPreferencesCard from "../components/portal/PortalNotificationPreferencesCard";
import PortalPageHeading from "../components/portal/PortalPageHeading";
import PortalProfileCard from "../components/portal/PortalProfileCard";
import PortalSignInPasswordCard from "../components/portal/PortalSignInPasswordCard";
import { usePortalPage } from "../features/portal/hooks/usePortalPage";

/**
 * Me (US-66): the shown member's details and language, the signed-in person's own sign-in password (US-113,
 * not while a ward is shown), consents, "Tell us what's missing" (US-99), data export and deletion request —
 * a guardian switches to a ward for these. The email settings stay the signed-in member's own and say so
 * while a ward is shown.
 */
const PortalMePage = () => {
  const { t } = useTranslation();
  const { session, me, memberId, members, selectMember } = usePortalPage();

  if (!session) return null;

  const shown = members.find((member) => member.memberId === memberId);
  const isSelf = shown?.isSelf ?? true;

  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-8">
      <PortalPageHeading
        title={t("portal.me.title")}
        intro={t("portal.me.intro")}
        members={members}
        memberId={memberId}
        onSelectMember={selectMember}
      />
      {memberId && (
        <div className="space-y-4">
          <PortalProfileCard memberId={memberId} isSelf={isSelf} />
          {isSelf && <PortalSignInPasswordCard />}
          <PortalConsentsCard memberId={memberId} />
          <PortalNotificationPreferencesCard ownerName={isSelf ? undefined : me?.self.firstName} />
          <PortalFeedbackCard memberId={memberId} />
          <PortalExportCard memberId={memberId} firstName={shown?.firstName ?? ""} isSelf={isSelf} />
          <PortalDeleteDataCard memberId={memberId} memberName={shown?.firstName ?? ""} />
        </div>
      )}
    </section>
  );
};

export default PortalMePage;
